<top-banner variant="title" title="Reports"></top-banner>
<div class="main-content">
  <div class="row">
    <div class="col-md-12">

      <div class="card" *ngIf="isAdminUser">
        <div class="card-body">

          <div *ngIf="!siteOwners.length" style="text-align: center;">
            <p-progressSpinner></p-progressSpinner>
          </div>

          <ng-container *ngIf="siteOwners.length">
            <h6>Select a site owner</h6>
            <p-dropdown
              class="form-control"
              [(ngModel)]="selectedSiteOwner"
              [ngModelOptions]="{standalone: true}"
              [options]="siteOwners"
              (ngModelChange)="selectedSiteOwnerChange()"
              placeholder="Select a site owner..."
              [style]="{'width':'100%'}"
              filter="true"
            ></p-dropdown>
            <br>
          </ng-container>
        </div>
      </div>

      <div class="grid-container">
        <app-worker-competency-and-training-report [siteOwnerId]="siteOwnerId"></app-worker-competency-and-training-report>
        <app-contractor-competency-report [siteOwnerId]="siteOwnerId"></app-contractor-competency-report>
        <confined-space-competency-and-training-report [siteOwnerId]="siteOwnerId" *ngIf="showConfinedSpaceCard || isPowerStationUser"></confined-space-competency-and-training-report>
        <div *ngIf="isPowerStationUser" class="card card-report">
          <div class="card-header">
            <h5 class="title">Outage Acceptance</h5>
          </div>

          <div class="card-body card-report__overflow">
            <div class="row">
              <div class="col-md-12">
                <p>Select an outage and view pending and complete acceptances by contractors</p>
              </div>
            </div>
          </div>

          <div class="card-report__actions">
            <button type="button" [disabled]="!siteOwnerId" (click)="goToOutages()" class="btn btn-success btn-round">
              <strong>View Outages</strong>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
